import './index.css';
import I18n from '../../utilities/locale';
import React from 'react';
import { AiFillWarning as Warning } from 'react-icons/ai';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import Text from '../text';
interface Props {
  onPressRetry?: React.MouseEventHandler;
}
const ErrorMessage = ({ onPressRetry }: Props) => {
  const { ErrorTheme: theme } = useTheme();
  const errorHeader = {
    color: theme.messageHeader
  };
  const errorMessage = {
    color: theme.messageText
  };
  const buttonColor = {
    backgroundColor: theme.tryAgainButton
  };
  const tryAgainColor = {
    color: theme.tryAgainText
  };
  return (
    <View className="error-message-container">
      <View className="error-message-sub-container">
        <View className="error-message-icon-wrapper">
          <Warning size={40} fill={theme.infoCircleIcon} />
        </View>
        <Text style={errorHeader} className="error-message-header">
          {I18n.t('SomethingWentWrong')}
        </Text>
        <Text style={errorMessage} className="error-message-label">
          {I18n.t('ErrorMessage')}
        </Text>
      </View>
      <View style={buttonColor} onPress={onPressRetry} className="error-message-btn">
        <Text style={tryAgainColor} className="error-message-btn-label">
          {I18n.t('TryAgain')}
        </Text>
      </View>
    </View>
  );
};
export default React.memo(ErrorMessage);
